import React from 'react';
import useProviderProfilePageContainerData from './useProviderProfilePageContainerData';

interface IProviderProfilePageContainerProps {
  url: string;
  checkAvailabilityUrl: string;
  mobileOrStudio?: string;
  offerKey?: string;
  children?: any;
}

const ProviderProfilePageContainer: React.FC<
  IProviderProfilePageContainerProps
> = ({
  url,
  offerKey,
  children,
  mobileOrStudio = 'mobile',
  checkAvailabilityUrl,
}) => {
  const props = useProviderProfilePageContainerData(
    url,
    mobileOrStudio,
    checkAvailabilityUrl,
    offerKey
  );
  return (typeof children === 'function' && children(props)) || null;
};
export default ProviderProfilePageContainer;
